// MobileContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';

const MobileContext = createContext<boolean>(false);

export const MobileProvider = ({ children }: { children: React.ReactNode }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const check = () => {
            const { userAgent } = navigator;
            const mobileMatch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
            const smallScreen = window.innerWidth <= 768;

            setIsMobile(mobileMatch || smallScreen);
        };

        check();
        window.addEventListener('resize', check);
        return () => window.removeEventListener('resize', check);
    }, []);

    return <MobileContext.Provider value={isMobile}>{children}</MobileContext.Provider>;
};

export const useIsMobile = () => useContext(MobileContext);

export const getWebOrMobileClass = (isMobile: boolean) => {
    return isMobile ? 'mobile' : 'web';
};
